"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getContentType_1 = require("../helpers/getContentType");
const getState_1 = require("../helpers/getState");
const entity_1 = require("../type/entity");
const isGradable_1 = require("./helpers/isGradable");
function updateGradableFieldForNonRoot(content, user, states) {
    const state = getState_1.getStateByContentIdUserId(states, content._id, user.userId);
    const childrenStates = getState_1.getChildrenStatesForContentByUserId(states, content, user.userId);
    const pendingForGradeStates = childrenStates.filter(childState => !!childState.pendingForGrades);
    if (pendingForGradeStates.length > 0) {
        state.pendingForGrades = true;
    }
    else {
        state.pendingForGrades = false;
    }
}
function updateGradableFieldForAssignmentCard(content, state) {
    if (state.forceComplete) {
        state.pendingForGrades = false;
    }
    else if (isGradable_1.isGradable(content) && state.completionStatus === entity_1.CompletionStatus.COMPLETE
        && entity_1.SuccessStatus.NOT_APPLICABLE) {
        state.pendingForGrades = true;
    }
    else {
        state.pendingForGrades = false;
    }
}
function updateGradableField(user, content, states) {
    const contentType = getContentType_1.getContentType(content);
    const state = getState_1.getStateByContentIdUserId(states, content._id, user.userId);
    switch (contentType) {
        case entity_1.ContentType.ASSIGNMENT_CARD:
            updateGradableFieldForAssignmentCard(content, state);
            break;
        case entity_1.ContentType.SECTION:
        case entity_1.ContentType.COURSE:
            updateGradableFieldForNonRoot(content, user, states);
            break;
        default:
            break;
    }
}
exports.updateGradableField = updateGradableField;
//# sourceMappingURL=updateGradableField.js.map